import { Component } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { Me } from "./api/me/me.models";

@Component({
  selector: "navbar",
  template: require('./navbar.component.html'),
  styles: [require('./navbar.component.scss')],
})
export class NavbarComponent {
  isAuthenticated = false;
  me: Me;
  hostname = "";

  constructor(private auth: AuthenticationService) {
    this.hostname = window.location.hostname;
    this.auth.isAuthenticated().subscribe((authenticated: boolean) => {
      this.isAuthenticated = authenticated;
      this.me = this.auth.getMe();
    });
  }

  getLogoUrl() {
    const hostname = !this.hostname || this.hostname === "127.0.0.1" ? "localhost" : this.hostname;

    return `/img/logotypes/${hostname}.png`;
  }

  signOut(event: Event) {
    event.preventDefault();
    this.auth.signOut();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/navbar.component.ts